import React, { Component } from 'react'
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import  BreadCrumb  from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { AddButton } from 'app/components/Button/AddButton';
import { reducer, sliceKey } from "./redux/slice";

import { useStyles } from "./styles";
import AdminCatalogTable from "./components/CatalogTable"
import {
  selectCatalogs,
  selectIsLoading,
  selectError
} from "./redux/selector";


const AdminCatalog = () => {
const styles = useStyles();
const { t, i18n } = useTranslation();
const rows = useSelector(selectCatalogs)
const loading = useSelector(selectIsLoading) 

useInjectReducer({
  key: sliceKey,
  reducer,
});





    
  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.CATALOGS")} iconPosition="end" />
            <Box>
              <AddButton label={t("CATALOGS.ADD")}/>
            </Box>
            <AdminCatalogTable rows={rows} loading={loading} />
          </Box>
        </Box>
    </Box>
  )
}

export default AdminCatalog
